import React, { Component } from "react";
import { Form, Radio } from "semantic-ui-react";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { updateTestAttendee } from "./testPageActions";
import firebase from "../../config/firebase";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { Prompt } from "react-router";
import Clock from "./Clock";
import NavigationBlockModal from "./NavigationBlockModal";

const mapState = state => ({
  // data: state.test.data,
  data: state.testQ,
  testCollection: state.selection.selectedCategory,
  testId: state.selection.selectedTest,
  testTree: state.userTestTreeReducer.testTree
});

const actions = {
  updateTestAttendee
};

class NewTestPage extends Component {
  documentSnapshot = {};
  dataItems = [];
  items = [];
  attendeeList = [];
  state = {
    formSubmitted: false,
    loading: true,
    isTaken: false,
    countdown: false,
    active: true,
    windowHeight: null,
    count: 1800,
    open: false
  };

  async componentDidMount() {
    const { testCollection, testId } = this.props;
    this.setState({
      windowHeight: window.innerHeight
    });
    let isTaken = this.isTaken(testId);
    try {
      this.documentSnapshot = await firebase
        .firestore()
        .collection(testCollection)
        .doc(testId)
        .get();
      this.setState({
        loading: false,
        isTaken
      });
    } catch (error) {
      console.log("Fetching error in NewTestPage ", error);
    }

    try {
      let attendeeSnapShot = await firebase
        .firestore()
        .collection(testCollection)
        .doc(testId)
        .collection("attendees")
        .get();

      console.log("attendeeSnapShot ", attendeeSnapShot);
      this.attendeeList = attendeeSnapShot.docs;
    } catch (error) {
      console.log("error in fetching attendee list", error);
    }

    this.fetchData();
    this.timer = setInterval(() => {
      const newCount = this.state.count - 1;
      this.setState({ count: newCount >= 0 ? newCount : 0 });
    }, 1000);
  }

  stopTimer() {
    this.setState({ count: 0 });
    clearInterval(this.timer);
  }

  // componentDidUpdate = () => {
  //     if (!this.state.formSubmitted) {
  //         window.onbeforeunload = () => true;
  //     } else {
  //         window.onbeforeunload = undefined;
  //     }
  // };

  componentWillUnmount = () => {
    clearInterval(this.timer);
  };

  handlePrompt = () => {
    console.log("handlePrompt() called ");
  };

  isTaken = testId => {
    const { testCollection, testTree } = this.props;
    if (testTree["testTree"]) {
      if (testTree["testTree"].hasOwnProperty(testCollection)) {
        let testArray = testTree["testTree"][testCollection];
        for (let i = 0; i < testArray.length; i++) {
          if (testId === testArray[i]) {
            return true;
          }
        }
      }
      return false;
    }
  };

  handleChange = (e, key, value) => {
    console.log("key ", key);
    if (!this.state.formSubmitted) {
      let items = Object.assign(this.dataItems);
      // console.log("items ", this.items);
      this.items[key - 1].selectedValue = value;
      this.setState({ items });
    }
    // console.log("my state ", this.state.items);
  };

  objectToArray = object => {
    if (object) {
      return Object.entries(object).map(e => Object.assign(e[1], { id: e[0] }));
    }
  };

  handleSubmit = event => {
    // console.log("handle submit called");
    event.preventDefault();
    this.formSubmitted = true;
    this.setState({ formSubmitted: true });
    const { updateTestAttendee } = this.props;
    let testScore = 0;
    for (let i = 0; i < this.dataItems.data.length; i++) {
      if (this.items[i].selectedValue === this.dataItems.data[i].answer) {
        testScore++;
      }
    }

    let totalAttendees = this.attendeeList.length + 1;
    // console.log("test Score, totalAttendees ", testScore, totalAttendees);

    let avgScore = (this.dataItems.avgScore + testScore) / totalAttendees;
    let topScore = this.dataItems.topScore;
    if (testScore > topScore) {
      topScore = testScore;
    }
    console.log(
      "test Score, avgScore, topScore,  totalAttendees ",
      testScore,
      avgScore,
      topScore,
      totalAttendees
    );
    updateTestAttendee(this.documentSnapshot, testScore, avgScore, topScore);
    this.stopTimer();
    if (this.state.open) {
      this.handleCloseModal();
    }
    // console.log("on handle submit ", value);
  };

  fetchData() {
    this.dataItems = this.documentSnapshot.data();
    // console.log("Questions ", this.dataItems);
    let formSubmitted = false;
    for (var i = 0; i < this.dataItems.data.length; i++) {
      let obj = {
        key: i + 1,
        selectedValue: ""
      };
      this.items.push(obj);
    }

    this.setState({
      items: this.items,
      dataItems: this.dataItems.data,
      formSubmitted
    });
  }

  toastrMessage = () => {
    console.log("toastr message");
  };

  handleContextRef = contextRef => this.setState({ contextRef });

  handleCloseModal = () => {
    this.setState({
      open: !this.state.open
    });
  };

  handleBlockedNavigation = nextLocation => {
    if (!this.state.formSubmitted && !this.state.isTaken) {
      this.showModal();
      return false;
    }

    return true;
  };

  showModal = () => {
    this.setState({
      open: true
    });
  };

  render() {
    // this.items = this.dataItems.data().data;
    // console.log("this .items ", this.items);
    // const message = "Question is not set yet. Will be soon.";

    // try {
    //     // toastr.confirm(message, {
    //     //     onOk: () => this.toastrMessage
    //     // });
    //     toastr.message("Message", message);
    // } catch (error) {
    //     console.log(error);
    // }
    // const { active, contextRef } = this.state;
    // console.log("items in render() ", this.items);
    if (this.state.loading) return <LoadingComponent inverted={true} />;
    return (
      <React.Fragment>
        <Prompt
          when={!this.state.formSubmitted && !this.state.isTaken}
          message={this.handleBlockedNavigation}
        />
        <NavigationBlockModal
          open={this.state.open}
          onClose={this.handleCloseModal}
          handleCloseModal={this.handleCloseModal}
          handleSubmit={this.handleSubmit}
        />
        {/* Component JSX */}

        <div
        //   style={{
        //     height: this.state.windowHeight
        //   }}
        >
          {!this.state.isTaken && (
            <div
            //   style={{
            //     textAlign: "center",
            //     height: "5%",
            //     margin: 10
            //   }}
            >
              <Clock time={this.state.count} />
            </div>
          )}

          <div
            ref={this.handleContextRef}
            style={{
              height: "90%",
              overflow: "hidden",
              overflowY: "scroll"
            }}
          >
            {/* <h1>I'm test</h1> */}
            {/* <Grid columns={15}> */}
            <Form>
              {this.items &&
                this.items.map((item, index) => (
                  <Paper
                    key={item.key}
                    style={{
                      padding: "20px",
                      margin: "20px"
                    }}
                  >
                    <div>
                      <Form.Field>
                        {item.key}. Question is:{" "}
                        <b>{this.state.dataItems[index].question}</b>
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label={this.state.dataItems[index].optionOne}
                          value={this.state.dataItems[index].optionOne}
                          checked={
                            item.selectedValue ===
                            this.state.dataItems[index].optionOne
                          }
                          onChange={e =>
                            this.handleChange(
                              e,
                              item.key,
                              this.state.dataItems[index].optionOne
                            )
                          }
                          disabled={this.state.count === 0}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label={this.state.dataItems[index].optionTwo}
                          value={this.state.dataItems[index].optionTwo}
                          checked={
                            item.selectedValue ===
                            this.state.dataItems[index].optionTwo
                          }
                          onChange={e =>
                            this.handleChange(
                              e,
                              item.key,
                              this.state.dataItems[index].optionTwo
                            )
                          }
                          disabled={this.state.count === 0}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label={this.state.dataItems[index].optionThree}
                          value={this.state.dataItems[index].optionThree}
                          checked={
                            item.selectedValue ===
                            this.state.dataItems[index].optionThree
                          }
                          onChange={e =>
                            this.handleChange(
                              e,
                              item.key,
                              this.state.dataItems[index].optionThree
                            )
                          }
                          disabled={this.state.count === 0}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label={this.state.dataItems[index].optionFour}
                          value={this.state.dataItems[index].optionFour}
                          checked={
                            item.selectedValue ===
                            this.state.dataItems[index].optionFour
                          }
                          onChange={e =>
                            this.handleChange(
                              e,
                              item.key,
                              this.state.dataItems[index].optionFour
                            )
                          }
                          disabled={this.state.count === 0}
                        />
                      </Form.Field>
                      <Form.Field>
                        {this.state.isTaken ? (
                          <span>
                            {" "}
                            Correct Answer: {this.dataItems.data[index].answer}
                          </span>
                        ) : (
                          <span>
                            Your answers is : <b>{item.selectedValue}</b>
                          </span>
                        )}
                        {/* Your answers is :{" "}
                                        <b>{item.selectedValue}</b> */}
                      </Form.Field>
                      {this.state.formSubmitted ? (
                        <Form.Field>
                          {item.selectedValue ===
                          this.dataItems.data[index].answer ? (
                            <p
                              style={{
                                color: "green"
                              }}
                            >
                              Your answer is correct.
                            </p>
                          ) : (
                            <p
                              style={{
                                color: "red"
                              }}
                            >
                              Sorry your answer is not correct. Correct answer
                              would be: {this.dataItems.data[index].answer}
                            </p>
                          )}
                        </Form.Field>
                      ) : null}

                      <br />
                    </div>
                  </Paper>
                ))}
              {!this.state.formSubmitted && !this.state.isTaken && (
                <div
                  style={{
                    background: "#eee",
                    justifyItems: "center",
                    borderRadius: 5,
                    margin: 20
                  }}
                >
                  <Form.Button
                    positive
                    content="Submit"
                    style={{
                      width: "100%"
                    }}
                    onClick={e => this.handleSubmit(e)}
                  />
                </div>
              )}
            </Form>

            {/* <Segment> */}
            {/* {!this.state.isTaken && (
                    <Rail internal position="right" size="massive">
                        <Sticky
                            active={active}
                            bottomOffset={50}
                            context={contextRef}
                            offset={100}
                            style={{
                                textAlign: "center"
                            }}
                        >
                            <Countdown
                                date={Date.now() + 1800000}
                                renderer={this.renderer}
                            />
                        </Sticky>
                    </Rail>
                )} */}
            {/* </Segment> */}

            {/* </Grid> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    mapState,
    actions
  )(NewTestPage)
);
